export default "__VITE_ASSET__73292949__"